import React, {
  Component
} from 'react';

import {
  SalesContext
} from 'src/Context/SalesContext';

import {
  addBeforeloadEvent,
  removeBeforeloadEvent,
  whatsappUs
} from 'src/Utility/utility';

import {
  tagOnFibrePlanDetails,
  tagOnPlanDetailsContractDurationClick,
  tagOnPlanDetailsProviderClick
} from 'src/Tagging/SalesTagging';

import {
  AdditionalServices
} from 'src/UI/NewPlanDetails/components/AdditionalServices';

import {
  CallIconBlack,
  VettingLeftArrow,
  WhatsappIcon
} from 'src/Components/Common';

import {
  getAdditionalServices
} from 'src/Services/Services';

import {
  DurationIcon,
  TrolleyIcon,
  CheckvronUpIcon,
  CheckvronDownIcon,
  CloseButtonSmall,
  BlackDot,
  InfoIcon,
  WhiteDot,
  BluePromotionIcon,
  ChevronLeft
} from 'src/Components/Common/Svg';

import WhatsappBtn from 'src/Components/Common/WhatsappBtn/WhatsappBtn';

import CallMeBackBtn from 'src/Components/Common/CallMeBackBtn/CallMeBackBtn';

import ContractTermOptions from './components/ContractTermOptions';

import Plan from './components/Plan';

import InstallationAddress from './components/InstallationAddress';

import Footer from './components/Footer';

import ReadMore from './components/ReadMore';

import ErrorPopup from 'src/Components/Common/ErrorPopup/ErrorPopup';

import './NewPlanDetails.css';

class NewPlanDetails extends Component {
  static contextType = SalesContext;

  state = {
    fixedInclusions: [ 'Activation', 'Installation', 'Router' ],
    showRouterDeliveryFee: true,
    routerDeliveryFee: 199,
    additionalServices: null,
    selectedTerm: '',
    totalMonthlyCost: null,
    totalOnceOffCost: null,
    isLteToggle: false,
    currentToggleState: false,
    description: null,
    promotion: '',
    offeringID: '',
    vasCategory: '',
    displayName: '',
    priceDescription: null,
    selectedDiscountTerm: '',
    isMonthlySection: true,
    isTodaySection: false,
    learnMoreOnSuperWifi: false,
    learnMoreOnContractCover: false,
    isOpeningContainer: false,
    isHelp: false
  };

  handleContractChange = (selectedContract) => {

    tagOnPlanDetailsContractDurationClick(selectedContract);
    this.context.setSelectedContractTerm(selectedContract);
    const term = this.context.contractTerms.find(t => t.duration === selectedContract);
    const firstProvider = term.providers[0];

    this.context.setPlanProviders(term.providers || []);
    this.context.setSelectedPackage(firstProvider);
  };

  handleProviderChange = (selectedProvider) => {

    tagOnPlanDetailsProviderClick(selectedProvider.provider);
    this.context.setSelectedPackage(selectedProvider);
  };

  toggleContract = (key) => {
    this.setState((prevState) => ({ [key]: !prevState[key] }));
  };

  onBackButton = () => {

    window.location.href = '/cloud/fibre/sales/choosePlan';
  }

  onHelp = () => {
    this.setState(prevState => ({
      isHelp: !prevState.isHelp
    }));
  }

  toggleContainer = () => {
    this.setState(prevState => ({
      isOpeningContainer: !prevState.isOpeningContainer
    }));
  };

  onLearnMore = (type) => {
    this.setState((prevState) => ({
      learnMoreOnSuperWifi: type === 'learnMoreOnSuperWifi' ? !prevState.learnMoreOnSuperWifi : false,
      learnMoreOnContractCover: type === 'learnMoreOnContractCover' ? !prevState.learnMoreOnContractCover : false
    }));
  };

  onCloseButton = (type) => {
    this.setState({
      [type]: false,
      isHelp: false
    });
  };

  handleToggle = () => {
    this.setState(prevState => ({
      isLteToggle: !prevState.isLteToggle
    }), () => this.handleCurrentToggleState(this.state.isLteToggle));
  }

  handleCurrentToggleState = (isLteToggleValue) => {
    this.setState({
      currentToggleState: isLteToggleValue
    });
  }

  handleUpdateAddress = (addressLine) => {
    const newAddress = { ...this.context.installationAddress, [addressLine.key]: addressLine.value };
    this.context.setInstallationAddress(newAddress);
  }

  openCallmeBackPopup = () => {
    this.context.setShowCallMeBack(true);
    this.setState({ isHelp: false });
  }

  submitFormClickHandler = () => {
    const { history } = this.props;
    history.push(this.context.leadAdditionalServices?.length >= 1 ? '/cloud/fibre/sales/contactInformation' : '/cloud/fibre/sales/deliveryAddress');
  }

  init = async () => {

    const plans = this.context?.plans || [];

    const contractTerms = plans.map(plan => ({
      duration: plan.duration,
      providers: plan.providers
    }));

    this.context.setContractTerms(contractTerms || []);

    const contractOptions = contractTerms.map(term => ({
      label: term.duration,
      value: term.duration
    }));

    this.context.setContractOptions(contractOptions || []);

    const initialTerm = contractTerms.find(term => term.duration === this.context.selectedContractTerm);

    const initialProvider = initialTerm.providers?.[0] || {};
    tagOnPlanDetailsContractDurationClick(this.context.selectedContractTerm);

    this.context.setPlanProviders(initialTerm.providers || []);
    tagOnPlanDetailsProviderClick(initialProvider.provider);

    this.context.setSelectedPackage(initialProvider);

    if (!this.context.additionalServices) {

      try {

        const additionServices = await getAdditionalServices();

        additionServices.serviceCategories.map(el => {
          if (el.vasCategory === 'voip') {
            el.vasCategory = 'voiceLine';
          }
          this.context.setSelectedAdditionalServices({ key: el.vasCategory, value: false });
        });
        this.context.setAdditionalServices(additionServices);
      } catch {
        console.log('Failed to fetch additional services');
      }
    }

  };

  componentWillUnmount = () => {
    removeBeforeloadEvent();
  }

  componentDidMount = () => {
    window.scrollTo(0, 0);
    this.init();
    addBeforeloadEvent();

    if (this.context.selectedPackage) {
      tagOnFibrePlanDetails(this.context?.selectedPackage?.provider + ' - ' + this.context?.selectedPackage?.description, 1, this.context?.selectedPackage?.productPrice?.value);
    }
  }

  render() {

    let discount = parseFloat(this.context?.selectedPackage?.productPrice?.value) - parseFloat(this.context?.selectedPackage?.discountAmount);
    let additionalServicesVAS = [];

    if (this.context.additionalServices && this.context.additionalServices.serviceCategories) {
      this.context.additionalServices.serviceCategories.map((service) => {
        additionalServicesVAS.push(service.vasCategory);
      });
    }

    let monthlyTotal = 0;
    let onceOffTotal = this.state.showRouterDeliveryFee ? this.state.routerDeliveryFee : 0;

    if (this.context.additionalVas) {
      this.context.additionalVas.map(item => {
        if (parseInt(item?.contractTerm) === parseInt(this.context.selectedContractTerm) || item.category === 'contractCover') {
          monthlyTotal += parseFloat(item?.price?.replace('R', ''));
        } else {
          onceOffTotal += parseFloat(item?.price?.replace('R', ''));
        }
      });
      if (parseFloat(discount) > 0) {
        monthlyTotal += discount;
      } else {
        monthlyTotal += parseFloat(this.context.selectedPackage?.productPrice?.value);
      }
    } else {
      monthlyTotal = parseFloat(this.context.selectedPackage?.productPrice?.value);
    }

    monthlyTotal = parseFloat(monthlyTotal).toFixed(2);
    onceOffTotal = parseFloat(onceOffTotal).toFixed(2);

    return (
      <>
        {!this.context.getOffersError ?

          <>
            <div className='new-plan-details-main-wrapper'>

              {this.state.learnMoreOnSuperWifi && (
                <div className='plan-details-learn-container'>
                  <div className='plan-details-learn'>
                    <ReadMore type={'superWifi'} />
                    <div onClick={() => this.onCloseButton('learnMoreOnSuperWifi')}><CloseButtonSmall /></div>
                  </div>
                </div>
              )
              }

              {this.state.learnMoreOnContractCover && (
                <div className='plan-details-learn-container'>

                  <div className='plan-details-learn'>
                    <ReadMore type={'cover'} />
                    <div onClick={() => this.onCloseButton('learnMoreOnContractCover')}><CloseButtonSmall /></div>
                  </div>
                </div>
              )
              }

              <div className='new-plan-details-back' onClick={this.onBackButton}>

                <div className="new-plan-details-back-arrow">
                  <ChevronLeft color='black' />
                </div>
                <p className="new-plan-details-back-arrow-text">Back</p>

              </div>

              <div className="new-plan-details-main-heading-container">
                <p className="new-plan-details-main-heading">
                  Customise
                </p>
                <p className="new-plan-details-sub-heading">your fibre plan</p>
              </div>

              {!this.context.selectedPackage
                ? null
                : <div className={'new-plan-details-container'}>

                  {/* Left Side */}
                  <div className='new-plan-details-review-plan-main-container'>

                    {/* Plan Details*/}
                    <div className="new-plan-details-review-plan">

                      <div className="new-plan-details-review-plan-vertical-line-container">
                        <div className="new-plan-details-review-plan-dark-circle">
                          <BlackDot />
                        </div>
                        <div className="new-plan-details-review-plan-vertical-line"></div>
                        <div className="new-plan-details-review-plan-white-circle">
                          <WhiteDot />
                        </div>
                      </div>

                      <div className="new-plan-details-review-plan-wrapper">
                        <span className="new-plan-details-review-plan-wrapper-step">
                          STEP 1
                        </span>

                        <h3 className="new-plan-details-review-plan-wrapper-header">
                          Review your plan
                        </h3>

                        <Plan 
                          planDetails={this.context.plans[0].providers[0]} 
                          inclusions={this.context?.selectedPackage?.inclusions} />

                        <span className='new-plan-details-review-plan-wrapper-point'>Select your provider & contract duration</span>
                      </div>
                    </div>

                    {/* Contract Terms*/}
                    <div className="new-plan-details-contract-terms">
                      <div className="new-plan-details-review-plan-vertical-line-container">
                        <div className="new-plan-details-review-plan-vertical-line"></div>
                      </div>

                      <div className="contract-terms-wrapper">
                        <ContractTermOptions
                          options={this.context?.contractOptions}
                          providers={this.context?.planProviders}
                          selectedOption={this.context?.selectedContractTerm}
                          selectedOfferingID ={this.context?.selectedPackage?.offeringID}
                          onContractChange={this.handleContractChange}
                          onProviderChange={this.handleProviderChange}
                          totalPrice={this.context?.selectedPackage?.productPrice?.value}
                          discount={discount}
                          onDiscount={this.context?.selectedPackage?.onDiscount}
                          saving={this.context?.selectedPackage?.discountTerm}
                          inclusions={this.context?.selectedPackage?.inclusions}
                        />
                      </div>
                    </div>

                    {/* Installation Address*/}
                    <div className="new-plan-details-review-plan-installation-address">

                      <div className="new-plan-details-review-plan-vertical-line-container">
                        <div className="new-plan-details-review-plan-dark-circle">
                          <BlackDot />
                        </div>
                        <div className="new-plan-details-review-plan-vertical-line"></div>
                      </div>

                      <div className="new-plan-details-review-installation-address-wrapper">
                        <span className="new-plan-details-review-plan-wrapper-step">
                          STEP 2
                        </span>

                        <h3 className="new-plan-details-review-plan-wrapper-header">
                          Review your installation address
                        </h3>

                        <span className='new-plan-details-description'>We&apos;ll install and activate your fibre at this location.</span>

                        <InstallationAddress
                          address={this.context.installationAddress}
                          onUpdateAddress={this.handleUpdateAddress} />
                      </div>
                    </div>

                    {/* Add some extras*/}
                    <div className="new-plan-details-review-plan-extras">

                      <div className="new-plan-details-review-plan-vertical-line-container">
                        <div className="new-plan-details-review-plan-dark-circle">
                          <BlackDot />
                        </div>
                        <div className="new-plan-details-review-plan-vertical-line"></div>
                      </div>

                      <div className="new-plan-details-review-installation-address-wrapper">
                        <span className="new-plan-details-review-plan-wrapper-step">
                          STEP 3 (Optional)
                        </span>

                        <h3 className="new-plan-details-review-plan-wrapper-header">
                          Add some extras
                        </h3>

                        <span className='new-plan-details-description'>Optional fibre add-ons let you customise your plan to fit your needs and budget</span>

                        <br />
                        <br />

                        {additionalServicesVAS.includes('contractCover') &&

                          <div className='new-plan-details-contract-cover-banner'>

                            <InfoIcon />

                            <div className='new-plan-details-contract-cover-banner-text'>
                              We have added Contract Cover by default because we believe in its value for you. You can remove it, but before you do, please read why we think you should keep it...
                            </div>

                          </div>
                        }
                      </div>
                    </div>

                    {additionalServicesVAS.length > 0

                      ? <AdditionalServices
                        updateTotalCost={this.OnProductSelect}
                        onLearnMore={this.onLearnMore} />
                      : null
                    }

                    {/* Ready to checkout*/}
                    <div className="new-plan-details-review-plan-ready-to-checkout-container">

                      <div className="new-plan-details-review-plan-vertical-line-container">
                        <div className="new-plan-details-review-plan-dark-circle">
                          <BlackDot />
                        </div>
                      </div>

                      <div className="new-plan-details-review-plan-ready-to-checkout">
                        <span className="new-plan-details-review-plan-wrapper-step">
                          STEP 4
                        </span>

                        <h3 className="new-plan-details-review-plan-wrapper-header">
                          Get ready to checkout
                        </h3>

                        <span className='new-plan-details-description'>Review your order on the right side of the screen. If you&apos;re happy with everything, click the &quot;Checkout&quot; button.</span>
                      </div>
                    </div>

                  </div>

                  {/* Right Side*/}
                  <div className="new-plan-details-contract-summary-container">
                    <div
                      className={
                        this.state.isMonthlySection
                          ? 'new-plan-details-contract-summary'
                          : 'new-plan-details-contract-summary-closed'
                      }>

                      <span className="new-plan-details-contract-summary-header">
                        Contract summary
                      </span>

                      <hr className="new-plan-details-contract-summary-divider" />

                      <div className="new-plan-details-contract-summary-monthly-payment">
                        <div className="new-plan-details-contract-summary-todays-payment-header">
                          Monthly payment
                        </div>

                        <div
                          className="new-plan-details-contract-summary-todays-payment-prize-container"
                          onClick={() => this.toggleContract('isMonthlySection')}
                        >
                          <span className="new-plan-details-contract-summary-todays-payment-prize">
                            {`R${ monthlyTotal } PM`}
                          </span>

                          {this.state.isMonthlySection
                            ? <CheckvronUpIcon />
                            : <CheckvronDownIcon />
                          }

                        </div>
                      </div>

                      {this.state.isMonthlySection && (
                        <>
                          <div
                            className={
                              this.state.isMonthlySection
                                ? 'new-plan-details-contract-summary-deal'
                                : 'new-plan-details-contract-summary-deal-close'
                            }>

                            <span className="new-plan-details-contract-summary-deal-heading">
                              Deal
                            </span>
                            <div className="new-plan-details-contract-summary-deal-description">
                              <span className="new-plan-details-contract-summary-deal-cap" >Uncapped fibre</span>

                              <span className="new-plan-details-contract-summary-deal-prize">
                                {this.context?.selectedPackage?.productPrice?.value }
                              </span>

                            </div>

                            {this.context?.selectedPackage?.onDiscount &&

                              <div className="new-plan-details-contract-summary-promotion-order-summary">
                                <BluePromotionIcon/>
                                <span className="new-plan-details-contract-summary-deal-tag">
                                  {`Only pay R${ discount } for the first ${ this.context?.selectedPackage?.discountTerm }`}
                                </span>
                              </div>
                            }

                            <span className="new-plan-details-contract-summary-deal-heading">
                              Add-ons
                            </span>
                            {this.context.additionalVas
                              ? this.context.additionalVas.map((item, index) => (
                                (item.displayName !== 'Super Wifi' && item.priceDescription !== '799') ? (
                                  <div key={index} className="new-plan-details-contract-summary-deal-description">
                                    <span className='new-plan-details-contract-summary-deal-cap'>{item?.displayName}</span>
                                    <span className="new-plan-details-contract-summary-deal-prize">
                                      {item?.price}
                                    </span>
                                  </div>
                                ) : null
                              ))
                              : null
                            }

                          </div>

                          <div className="new-plan-details-contract-summary-deal-duration">

                            <div className="new-plan-details-contract-summary-deal-logo">

                              <DurationIcon />

                              <span className="new-plan-details-contract-summary-deal-logo-text">
                                Contract duration:
                              </span>
                            </div>

                            <div>
                              <span className='new-plan-details-contract-summary-contract-duration'>{this.context.selectedContractTerm === 'Month to Month' ? 'Monthly' : this.context.selectedContractTerm}</span>
                            </div>
                          </div>
                        </>
                      )}

                      <hr className="new-plan-details-contract-summary-divider" />

                      <div className="new-plan-details-contract-summary-todays-payment">
                        <span className="new-plan-details-contract-summary-todays-payment-header">
                          Today’s payment
                        </span>

                        <div
                          className="new-plan-details-contract-summary-todays-payment-prize-container"
                          onClick={() => this.toggleContract('isTodaySection')}>

                          <span className="new-plan-details-contract-summary-todays-payment-prize">
                            {`R${ onceOffTotal }`}
                          </span>
                          {
                            this.state.isTodaySection
                              ? <CheckvronUpIcon />
                              : <CheckvronDownIcon />
                          }
                        </div>

                      </div>

                      {this.state.isTodaySection &&

                        <div className="new-plan-details-contract-summary-deal">

                          {this.state.fixedInclusions.map((item, index) => (
                            <div key={index} className="new-plan-details-contract-summary-deal-description">
                              <span className='new-plan-details-contract-summary-deal-cap'>{item}</span>
                              <span className="new-plan-details-contract-summary-deal-prize">
                                FREE
                              </span>
                            </div>
                          ))}

                          {this.state.showRouterDeliveryFee &&

                            <div className="new-plan-details-contract-summary-deal-description">
                              <span className='new-plan-details-contract-summary-deal-cap'>Router delivery</span>
                              <span className="new-plan-details-contract-summary-deal-prize">R{this.state.routerDeliveryFee}</span>
                            </div>
                          }

                          {this.context.additionalVas
                            ? this.context.additionalVas.map((item, index) => (
                              (item.displayName !== 'Contract Cover' && item.priceDescription === '799')
                                ? (<div key={index} className="new-plan-details-contract-summary-deal-description">
                                  <span className='new-plan-details-contract-summary-deal-cap'>{item?.displayName}</span>
                                  <span className="new-plan-details-contract-summary-deal-prize">{item?.price}</span>
                                </div>)
                                : null
                            ))
                            : null
                          }
                        </div>

                      }

                      <button onClick={this.submitFormClickHandler} className="new-plan-details-contract-summary-checkout-button">
                        <TrolleyIcon />
                        <span className="new-plan-details-contract-summary-checkout-button-text">
                          Checkout
                        </span>
                      </button>

                    </div>

                    <div className="new-plan-details-contract-summary-contact-us">

                      <span className="new-plan-details-contract-summary-contact-us-text">
                        Prefer speaking to a consultant?
                      </span>
                      <div className="new-plan-details-contract-summary-whatsapp-me">
                        <WhatsappBtn />
                      </div>
                      <div className="new-plan-details-contract-summary-call-me-back">
                        <CallMeBackBtn />
                      </div>

                    </div>
                  </div>
                </div>
              }
            </div >

            {/*Tablet View*/}
            <div className="new-plan-details-contract-summary-tablet-container">
              <div className="new-plan-details-contract-tablet-dragger">
                <div>
                  <button className='new-plan-details-contract-tablet-expander' onClick={this.toggleContainer}></button>
                </div>
              </div>

              {!this.state.isOpeningContainer

                ? <>
                  <div className="new-plan-details-contract-tablet-monthly">
                    <div className="new-plan-details-contract-summary-todays-payment-header">
                      Monthly payment
                    </div>

                    <div className="new-plan-details-contract-summary-todays-payment-prize-container">
                      <span className="new-plan-details-contract-summary-todays-payment-prize">
                        {`R${ monthlyTotal } PM`}
                      </span>
                    </div>
                  </div>

                  <div className="new-plan-details-contract-tablet-today">
                    <div className="new-plan-details-contract-summary-todays-payment">
                      <span className="new-plan-details-contract-summary-todays-payment-header">
                        Today’s payment
                      </span>

                      <div className="new-plan-details-contract-summary-todays-payment-prize-container">
                        <span className="new-plan-details-contract-summary-todays-payment-prize">
                          {`R${ onceOffTotal }`}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="new-plan-details-contract-tablet-help-container">

                    <button className="new-plan-details-tablet-info-button" onClick={this.onHelp}>
                      <InfoIcon color='black' />
                      <span className="new-plan-details-tablet-button-text">
                        Need Help?
                      </span>
                    </button>

                    <button onClick={this.submitFormClickHandler} className="new-plan-details-tablet-checkout-button">
                      <TrolleyIcon />
                      <span className="new-plan-details-tablet-button-text">
                        Checkout
                      </span>
                    </button>

                  </div>
                </>

                : <div
                  className={
                    this.state.isMonthlySection
                      ? 'new-plan-details-contract-summary'
                      : 'new-plan-details-contract-summary-closed'
                  }>

                  <span className="new-plan-details-contract-summary-header">
                    Contract summary
                  </span>

                  <hr className="new-plan-details-contract-summary-divider" />

                  <div className="new-plan-details-contract-summary-monthly-payment">
                    <div className="new-plan-details-contract-summary-todays-payment-header">
                      Monthly payment
                    </div>

                    <div
                      className="new-plan-details-contract-summary-todays-payment-prize-container"
                      onClick={() => this.toggleContract('isMonthlySection')}>

                      <span className="new-plan-details-contract-summary-todays-payment-prize">
                        {`R${ monthlyTotal } PM`}
                      </span>

                      {this.state.isMonthlySection
                        ? <CheckvronUpIcon />
                        : <CheckvronDownIcon />
                      }
                    </div>
                  </div>

                  {this.state.isMonthlySection &&
                    <>
                      <div
                        className={
                          this.state.isMonthlySection
                            ? 'new-plan-details-contract-summary-deal'
                            : 'new-plan-details-contract-summary-deal-close'
                        }>

                        <span className="new-plan-details-contract-summary-deal-heading">
                          Deal
                        </span>

                        <div className="new-plan-details-contract-summary-deal-description">

                          <span className='new-plan-details-contract-summary-deal-cap'>Uncapped fibre</span>

                          <span className="new-plan-details-contract-summary-deal-prize">
                            {this.context?.selectedPackage?.productPrice?.value }
                          </span>

                        </div>

                        {this.context?.selectedPackage?.onDiscount &&

                          <div className="new-plan-details-contract-summary-promotion">
                            <BluePromotionIcon/>
                            <span className="new-plan-details-contract-summary-deal-tag">
                              {`Only pay R${ discount } for the first ${ this.context?.selectedPackage?.discountTerm }`}
                            </span>
                          </div>
                        }

                        <span className="new-plan-details-contract-summary-deal-heading">
                          Add-ons
                        </span>

                        {this.context.additionalVas
                          ? this.context.additionalVas.map((item, index) => (
                            (item.displayName !== 'Super Wifi' && item.priceDescription !== '799') ? (
                              <div key={index} className="new-plan-details-contract-summary-deal-description">
                                <span className='new-plan-details-contract-summary-deal-cap'>{item?.displayName}</span>
                                <span className="new-plan-details-contract-summary-deal-prize">
                                  {item?.price}
                                </span>
                              </div>
                            ) : null
                          ))
                          : null
                        }
                      </div>

                      <div className="new-plan-details-contract-summary-deal-duration">
                        <div className="new-plan-details-contract-summary-deal-logo">
                          <DurationIcon />
                          <span className="new-plan-details-contract-summary-deal-logo-text">
                            Contract duration:
                          </span>
                        </div>
                        <div>
                          <span className='new-plan-details-contract-summary-contract-duration'>{this.context.selectedContractTerm === 'Month to Month' ? 'Monthly' : this.context.selectedContractTerm}</span>
                        </div>
                      </div>
                    </>
                  }
                  <hr className="new-plan-details-contract-summary-divider" />

                  <div className="new-plan-details-contract-summary-todays-payment">
                    <span className="new-plan-details-contract-summary-todays-payment-header">
                      Today’s payment
                    </span>

                    <div
                      className="new-plan-details-contract-summary-todays-payment-prize-container"
                      onClick={() => this.toggleContract('isTodaySection')}>

                      <span className="new-plan-details-contract-summary-todays-payment-prize">
                        {`R${ onceOffTotal }`}
                      </span>

                      {this.state.isTodaySection
                        ? <CheckvronUpIcon />
                        : <CheckvronDownIcon />
                      }

                    </div>
                  </div>

                  {this.state.isTodaySection &&
                    <div className="new-plan-details-contract-summary-deal">
                      {this.state.fixedInclusions.map((item, index) => (
                        <div key={index} className="new-plan-details-contract-summary-deal-description">
                          <span className='new-plan-details-contract-summary-deal-cap'>{item}</span>
                          <span className="new-plan-details-contract-summary-deal-prize">
                            FREE
                          </span>
                        </div>
                      ))}

                      {this.state.showRouterDeliveryFee &&

                        <div className="new-plan-details-contract-summary-deal-description">
                          <span className='new-plan-details-contract-summary-deal-cap'>Router delivery</span>
                          <span className="new-plan-details-contract-summary-deal-prize">R{this.state.routerDeliveryFee}</span>
                        </div>
                      }

                      {this.context.additionalVas
                        ? this.context.additionalVas.map((item, index) => (
                          (item.displayName !== 'Contract Cover' && item.priceDescription === '799') ? (
                            <div key={index} className="new-plan-details-contract-summary-deal-description">
                              <span className='new-plan-details-contract-summary-deal-cap'>{item?.displayName}</span>
                              <span className="new-plan-details-contract-summary-deal-prize">
                                {item?.price}
                              </span>
                            </div>
                          ) : null
                        ))
                        : null
                      }
                    </div>

                  }

                  <div className='new-plan-details-contract-summary-tablet-button-container'>

                    <div className='new-plan-details-mobile-container'>
                      <button className="new-plan-details-tablet-callmeback-button">
                        <CallIconBlack />
                        <span onClick={this.openCallmeBackPopup} className="new-plan-details-contract-summary-checkout-button-text">
                          Call Me back
                        </span>
                      </button>

                      <button onClick={whatsappUs} className="new-plan-details-tablet-whatsapp-button">
                        <WhatsappIcon />
                        <span className="new-plan-details-contract-summary-checkout-button-text">
                          WhatsApp us
                        </span>
                      </button>
                    </div>

                    <button onClick={this.submitFormClickHandler} className="new-plan-details-tablet-checkout-button">
                      <TrolleyIcon />
                      <span className="new-plan-details-contract-summary-checkout-button-text">
                        Checkout
                      </span>
                    </button>

                  </div>
                </div>
              }
            </div>

            <Footer />

            {/*Tablet Help Popup */}

            {this.state.isHelp &&
              <div className="plan-details-learn-container">
                <div className="tablet-help-popup-container">
                  <div className="address-line-cancel-icon-container">
                    <span
                      className="address-line-action"
                      onClick={this.onCloseButton}>
                      <CloseButtonSmall />
                    </span>
                  </div>

                  <div className="address-line-heading-container">
                    Need Help?
                  </div>
                  <div className="address-line-sub-heading-container">
                    For support in finalising your fibre package, get in touch with us via WhatsApp on 082 622 3509 or request a call back.
                  </div>

                  <div className='new-plan-details-contract-help-tablet-button-container'>

                    <button className="new-plan-details-tablet-callmeback-button" onClick={this.openCallmeBackPopup}>
                      <CallIconBlack />
                      <span className="new-plan-details-contract-summary-checkout-button-text">
                        Call Me back
                      </span>
                    </button>

                    <button onClick={whatsappUs} className="new-plan-details-tablet-whatsapp-button">
                      <WhatsappIcon />
                      <span className="new-plan-details-contract-summary-checkout-button-text">
                        WhatsApp us
                      </span>
                    </button>

                  </div>

                </div>
              </div>
            }
          </>
          :
          <ErrorPopup
            onCancelClick={this.onBackButton}
            onOkayClick={this.onBackButton} />
        }
      </>
    );
  }
}

export default NewPlanDetails;
